export default {
  title: 'Melden Sie sich unter Ihrer eigenen Adresse an',
  description:
    'Diese Adresse gehört zu einem Partner, zu dem Ihr Konto nicht gehört. Melden Sie sich zum Schutz Ihres Kontos dort an, wo Sie es sonst tun — Ihre E-Mail-Adresse und Ihr Passwort funktionieren dort.',
  continue: 'Weiter zu {{host}}',
  password_changed: 'Ihr Passwort wurde geändert.',
};
